import Layout from "../layout"

import mitt from 'mitt'
window.LOAD_EVENT = mitt()

class App extends Layout {
    constructor() {
        super()
        this.status = "loading"
        this.addEvents()
    }
    
    addEvents() {
        window.onload = (e) => this.loaded(e)
        window.addEventListener("pageshow",  (e) => this.pageShow(e))
        // window.onpopstate = (e) => this.reload(e)
    }

    loaded() {
        if (this.status == "loaded") return false
        this.status = "loaded"
        window.LOAD_EVENT.emit('loaded')
        this.preloader.hide()
    }

}

const _app = new App()